import React from "react"
import styled from "styled-components"
import Box from "../box"
import Text from "../text"
import theme from "../../theme/"
import Row from "../row"
import Column from "../column"
import { pets_highlights } from "../../constants/highlights.constant"
import { icons } from "src/assets"
import includes from "lodash.includes"

const Icon = styled.img`
  width: 32px;
  height: 32px;
  margin-bottom: ${theme.space[2]}px;
`
const HeadingH1 = styled.h2`
  text-decoration: none;
  margin-bottom: 18px;
  color: rgb(60, 66, 64);
  font-size: 32px;
  font-weight: 600;
`
const PetContainer = styled(Column as any)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: ${theme.space[4]}px;
  margin-right: ${theme.space[4]}px;
`

interface pet {
  id: string
  dog: boolean
  cat: boolean
  other: boolean
}
interface props {
  pets: pet
}

const SingleListingPetsSection = ({ pets }: props) => {
  let hasAtLeastOne = false
  delete pets?.__typename
  delete pets?.id
  let petsAllowed

  /*Will get the proper object from the array pets_highlights */

  if (pets !== null && pets !== undefined) {
    petsAllowed = (Object as any).keys(pets)
    let _values = (Object as any).values(pets)
    hasAtLeastOne = includes(_values, true)
  }
  return (
    <Box flexDirection="column" mb={[4]}>
      <HeadingH1>Pets Allowed</HeadingH1>
      <Row flexWrap={"wrap"}>
        {petsAllowed?.map((key: string) => {
          if (pets[key]) {
            const pet = pets_highlights.filter(elem => elem.name.toLowerCase() === key)[0]
            return (
              <PetContainer>
                <Icon src={pet.icon} alt="pets-accepted" />
                <Text fontSize={18} color={theme.colors.darkGrey} lineHeight={1.4}>
                  {pet.name}
                </Text>
              </PetContainer>
            )
          }
        })}
        {!hasAtLeastOne && (
          <PetContainer>
            <Icon src={icons.none} alt="pets-accepted" />
            <Text fontWeight={600}>None</Text>
          </PetContainer>
        )}
      </Row>
    </Box>
  )
}

export default SingleListingPetsSection
